// src/layouts/LayoutWithoutHeaderFooter.jsx
import AnimatedOutlet from "./Common/AnimatedOutlet/AnimatedOutlet";

const LayoutWithoutHeaderFooter = () => {
  return (
    // <div className="min-height-screen">
    <AnimatedOutlet />
    // </div>
  );
};

export default LayoutWithoutHeaderFooter;
